
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, ShipToAddressViewModel } from "@tylertech/tyler-api-types";

/**
 * ShipToLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ShipToLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<ShipToAddressViewModel[]>> {
        return this.$apiService.sendAuth("IShipToLookupService/Lookup", pCriteria);
    }
}
